import '@fontsource/plus-jakarta-sans/400'
import '@fontsource/plus-jakarta-sans/500'
import '@fontsource/plus-jakarta-sans/600'
import '@fontsource/plus-jakarta-sans/700'

import './theme/base.css'
import './theme/colors.css'
import './theme/globals.css'

import { PostHogProvider } from '@posthog/react'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { env } from './config/env'
import { initSentry } from './integrations/sentry'
import { routeTree } from './routeTree.gen'

initSentry()

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {env.posthog.key && env.posthog.host ? (
      <PostHogProvider apiKey={env.posthog.key} options={{ api_host: env.posthog.host }}>
        <RouterProvider router={router} />
      </PostHogProvider>
    ) : (
      <RouterProvider router={router} />
    )}
  </StrictMode>,
)
